const NavStatus = {
  LoginOrRegister: "loginorregister",
  Public: "public",
  ADMIN: "admin",
  BRAND: "brand",
};

export default NavStatus;
